const checkValidProp = function (userObj) {
	if (!userObj) return '---'
	return userObj
}

export default checkValidProp